module.exports = __webpack_public_path__ + "img/20190904164034799.fa4bac7e.jpg";